module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-17-5f89abdd5cc19dcf89381ab4133d8791.png";